import { render, staticRenderFns } from "./OwlFakeWidget.vue?vue&type=template&id=448fad52&scoped=true&"
import script from "./OwlFakeWidget.vue?vue&type=script&lang=js&"
export * from "./OwlFakeWidget.vue?vue&type=script&lang=js&"
import style0 from "./OwlFakeWidget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OwlFakeWidget.vue?vue&type=style&index=1&id=448fad52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448fad52",
  null
  
)

export default component.exports